import { clientFetch } from "@/utils/service";
import {
  FETCH_CENTERS,
  CREATE_CENTERS,
  UPDATE_CENTERS,
  DELETE_CENTERS,
  CREATE_CENTER_SERVICE,
  UPDATE_CENTER_SERVICE,
  DELETE_CENTER_SERVICE,
  CREATE_CENTER_SERVICE_PRICE,
  UPDATE_CENTER_SERVICE_PRICE,
  DELETE_CENTER_SERVICE_PRICE,
} from './types';
import { isFunction, qsToObj } from "@/utils/helpers";
import { toast } from "react-toastify";

const normalizeCenters = (data) => {
  return data.reduce((a, c) => {
    let servicesIds = c.services.map(s => {
      let servicesDescriptionsIds = s.service_descriptions.map((d) => {
        a.servicesDescriptions[d.id] = d;
        return d.id;
      });
      a.services[s.id] = { ...s, service_descriptions: servicesDescriptionsIds };
      return s.id
    })
    a.centers.allIds = [...a.centers.allIds, c.id];
    a.centers.byId[c.id] = { ...c, services: servicesIds };
    return a;
  }, {
    centers: { byId: {}, allIds: [] },
    services: {},
    servicesDescriptions: {},
  });
}

const basePath = '/admin/centers';
export const fetchCentersApi = async (query) => clientFetch(basePath, { query });
export const fetchCenters = (qs) => {
  const query = !!qs ? qsToObj(qs) : {};
  return {
    type: FETCH_CENTERS,
    payload: fetchCentersApi(query).then(normalizeCenters),
  };
};

export const manageCenters = async ({
  id,
  data = {},
  dispatch,
  onSuccess,
  onError,
}) => {
  const formData = {
    ...data,
  };
  const path = !!id ? `${basePath}/${id}` : basePath;
  const type = !!id ? UPDATE_CENTERS : CREATE_CENTERS;
  const method = !!id ? 'PATCH' : 'POST';

  return clientFetch(path, {
    method: method,
    body: JSON.stringify(formData),
  })
    .then((res) => {
      dispatch({
        type: `${type}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${type}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};

export const deleteCenters = (id, { onSuccess, t }) => {
  return {
    type: DELETE_CENTERS,
    payload: clientFetch(`${basePath}/${id}`, {
      method: 'DELETE',
    })
      .then((res) => {
        toast.success(t('centers.delete_success'));
        isFunction(onSuccess) && onSuccess(res);
        return { id };
      })
      .catch((err) => {
        toast.error(t('centers.delete_error'));
      }),
  };
};

// centerServices
const centerServicesBasePath = '/admin/services';
export const manageCenterService = async ({
  id,
  data = {},
  dispatch,
  onSuccess,
  onError,
}) => {
  const formData = {
    ...data,
  };
  const path = !!id ? `${centerServicesBasePath}/${id}` : centerServicesBasePath;
  const type = !!id ? UPDATE_CENTER_SERVICE : CREATE_CENTER_SERVICE;
  const method = !!id ? 'PATCH' : 'POST';

  return clientFetch(path, {
    method: method,
    body: JSON.stringify(formData),
  })
    .then((res) => {
      dispatch({
        type: `${type}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${type}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};

export const deleteCenterService = (id, { centerId, onSuccess, t }) => {
  return {
    type: DELETE_CENTER_SERVICE,
    payload: clientFetch(`${centerServicesBasePath}/${id}`, {
      method: 'DELETE',
    })
      .then((res) => {
        toast.success(t('centerServices.delete_success'));
        isFunction(onSuccess) && onSuccess(res);
        return { id, centerId };
      })
      .catch((err) => {
        toast.error(t('centerServices.delete_error'));
      }),
  };
};

// centerServicesPrice
const centerServicesPriceBasePath = '/admin/services-descriptions';
export const manageCenterServicePrice = async ({
  id,
  data = {},
  dispatch,
  onSuccess,
  onError,
}) => {
  const formData = {
    ...data,
  };
  const path = !!id
    ? `${centerServicesPriceBasePath}/${id}`
    : centerServicesPriceBasePath;
  const type = !!id ? UPDATE_CENTER_SERVICE_PRICE : CREATE_CENTER_SERVICE_PRICE;
  const method = !!id ? 'PATCH' : 'POST';

  return clientFetch(path, {
    method: method,
    body: JSON.stringify(formData),
  })
    .then((res) => {
      dispatch({
        type: `${type}_FULFILLED`,
        payload: res,
      });
      isFunction(onSuccess) && onSuccess(res);
    })
    .catch((err) => {
      dispatch({
        type: `${type}_REJECTED`,
        payload: err,
      });
      isFunction(onError) && onError(err);
    });
};

export const deleteCenterServicePrice = (id, { serviceId, onSuccess, t }) => {
  return {
    type: DELETE_CENTER_SERVICE_PRICE,
    payload: clientFetch(`${centerServicesPriceBasePath}/${id}`, {
      method: 'DELETE',
    })
      .then((res) => {
        toast.success(t('centerServicePriceManage.delete_success'));
        isFunction(onSuccess) && onSuccess(res);
        return { id, serviceId };
      })
      .catch((err) => {
        toast.error(t('centerServicePriceManage.delete_error'));
      }),
  };
};